/**
 * List all possible commands the system is capable of processing.
 */
export enum CommunicationTaskQueueWorkerListName {
  event = 'event',
  userList = 'userList',
}

export type CommunicationTaskQueueWorkerListNameType = keyof typeof CommunicationTaskQueueWorkerListName;
